import { Templates } from "@libema/core";

export default {
  ...Templates,
};
